import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { log } from 'console';
import { findIndex } from 'rxjs';
import { Common } from 'src/app/lib/common';

@Component({
  selector: 'app-date-popover',
  templateUrl: './date-popover.component.html',
  styleUrls: ['./date-popover.component.scss']
})
export class DatePopoverComponent {
  minWidth: number = 330
  selectedDate;
  @Input() defaultDate;

  years: number[] = []

  constructor(private popoverCtrl: PopoverController) { }

  ngOnInit() {
    this.selectedDate = new Date(this.defaultDate).toISOString()

    let dttm: Date = new Date()
    // Adds an extra year if we are in July or later (month is 0-based)
    let year: number = dttm.getFullYear() + Math.floor(dttm.getMonth() / 6)

    for (let i: number = (dttm.getFullYear() - 2); i <= year; i++) {
      this.years.push(i)
    }
  }

  updateDate(event){
    this.popoverCtrl.dismiss(event?.detail?.value)
  }

  onCancel(){
     this.popoverCtrl.dismiss(null);
  }

}
